'use strict';

import FlowModal from './modal.js';

export default function CommandPalette() {
  var self = this;
  this.actions = [];
  this.initialized = false;
  this._currentIdx = 0;
  this._results = [];
  this._query = '';

  var DEFAULTS = [
    { title: 'Dashboard', url: '/' },
    { title: 'Zones', url: '/zones' },
    { title: 'Users', url: '/users' },
    { title: 'Groups', url: '/groups' },
    { title: 'Bookings', url: '/bookings' },
    { title: 'Report', url: '/bookings?report=1' },
    { title: 'Billing', url: '/billing' },
    { title: 'Settings', url: '/profile/settings' },
    { title: 'Help', url: '/help' },
  ];

  this.init = function () {
    if (self.initialized) return;
    self.initialized = true;
    self._buildRegistry();
    document.addEventListener('keydown', self._onKeydown);
  };

  this._buildRegistry = function () {
    var seen = new Set();
    var registry = [];

    // Desktop nav links (top <nav> element)
    var desktopLinks = document.querySelectorAll('nav a[href]');
    desktopLinks.forEach(function (a) {
      var href = a.getAttribute('href');
      var text = (a.textContent || '').trim();
      if (href && text && !href.startsWith('#') && !href.startsWith('javascript') && !seen.has(href)) {
        seen.add(href);
        registry.push({ title: text, url: href });
      }
    });

    // Mobile bottom nav
    var mobileLinks = document.querySelectorAll('.mobile-bottom-nav a[href]');
    mobileLinks.forEach(function (a) {
      var href = a.getAttribute('href');
      var text = (a.textContent || '').trim();
      if (href && text && !seen.has(href)) {
        seen.add(href);
        registry.push({ title: text, url: href });
      }
    });

    // Hardcoded defaults (fill gaps from scraped nav)
    DEFAULTS.forEach(function (a) {
      if (!seen.has(a.url)) {
        seen.add(a.url);
        registry.push(a);
      }
    });

    self.actions = registry;
  };

  this._onKeydown = function (e) {
    if (!(e.ctrlKey || e.metaKey) || e.key.toLowerCase() !== 'k') return;

    var tag = e.target.tagName.toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;

    e.preventDefault();
    self._open();
  };

  this._open = function () {
    self._currentIdx = 0;
    self._results = [];
    self._query = '';

    var fm = FlowModal.getInstance();

    var wrapper = document.createElement('div');
    wrapper.className = 'flex flex-col h-full';

    // Search input — neobrutalist style per plan
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'w-full px-5 py-4 text-base font-bold border-2 border-neo-border rounded-neo shadow-neo-sm outline-none bg-white';
    input.placeholder = 'Search actions...';

    // Results list
    var list = document.createElement('div');
    list.className = 'flex-1 overflow-y-auto mt-3';
    self._renderResults(list, self.actions);

    // Footer hint
    var footer = document.createElement('div');
    footer.className = 'px-3 py-2 text-[11px] font-semibold text-neo-text-muted border-t border-neo-border/30 mt-2';
    footer.textContent = 'Type to search \u00b7 \u2191\u2193 navigate \u00b7 \u21b5 open \u00b7 Esc close';

    wrapper.appendChild(input);
    wrapper.appendChild(list);
    wrapper.appendChild(footer);

    fm.mount(wrapper, {
      onSetup: function () { input.focus(); },
      onClose: function () {
        self._currentIdx = 0;
        self._results = [];
        self._query = '';
        console.log('[CommandPalette] closed');
      },
    });

    // Live filtering on input
    input.addEventListener('input', function () {
      self._query = input.value;
      self._currentIdx = 0;
      self._renderResults(list, self._filter(input.value));
    });

    // Keyboard navigation
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var selected = list.querySelector('[data-idx="' + self._currentIdx + '"]');
        if (selected) {
          var url = selected.getAttribute('data-url');
          fm.unmount();
          window.location.href = url;
        }
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        self._moveHighlight(list, 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        self._moveHighlight(list, -1);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        fm.unmount();
      }
    });

    console.log('[CommandPalette] opened');
  };

  this._filter = function (query) {
    if (!query || !query.trim()) return self.actions;
    var q = query.toLowerCase().trim();
    return self.actions.filter(function (a) {
      return a.title.toLowerCase().indexOf(q) !== -1;
    });
  };

  this._renderResults = function (container, results) {
    self._results = results;
    container.innerHTML = '';

    var top = results.slice(0, 8);

    if (top.length === 0) {
      var empty = document.createElement('div');
      empty.className = 'py-6 px-5 text-center text-sm font-semibold text-neo-text-muted';
      empty.textContent = 'No matching actions';
      container.appendChild(empty);
      return;
    }

    top.forEach(function (action, i) {
      var item = document.createElement('div');
      item.setAttribute('data-url', action.url);
      item.setAttribute('data-idx', i);
      item.className =
        'flex items-center gap-3 px-4 py-3 rounded-neo cursor-pointer font-bold text-sm' +
        (i === self._currentIdx ? ' bg-neo-accent text-white' : ' hover:bg-neo-bg text-neo-text');

      var icon = document.createElement('i');
      icon.className = 'iconoir-page-share text-base flex-shrink-0';
      item.appendChild(icon);

      var span = document.createElement('span');
      span.textContent = action.title;
      item.appendChild(span);

      item.addEventListener('click', function () {
        FlowModal.getInstance().unmount();
        window.location.href = action.url;
      });

      item.addEventListener('mouseenter', (function (idx) {
        return function () {
          container.querySelectorAll('[data-idx]').forEach(function (el) {
            el.className = 'flex items-center gap-3 px-4 py-3 rounded-neo cursor-pointer font-bold text-sm hover:bg-neo-bg text-neo-text';
          });
          item.className = 'flex items-center gap-3 px-4 py-3 rounded-neo cursor-pointer font-bold text-sm bg-neo-accent text-white';
          self._currentIdx = idx;
        };
      })(i));

      container.appendChild(item);
    });
  };

  this._moveHighlight = function (container, dir) {
    var items = container.querySelectorAll('[data-idx]');
    if (items.length === 0) return;

    items[self._currentIdx].className = 'flex items-center gap-3 px-4 py-3 rounded-neo cursor-pointer font-bold text-sm hover:bg-neo-bg text-neo-text';

    self._currentIdx = Math.max(0, Math.min(self._currentIdx + dir, items.length - 1));

    items[self._currentIdx].className = 'flex items-center gap-3 px-4 py-3 rounded-neo cursor-pointer font-bold text-sm bg-neo-accent text-white';
  };
}

CommandPalette.Instance = null;
CommandPalette.getInstance = function () {
  if (!CommandPalette.Instance) CommandPalette.Instance = new CommandPalette();
  return CommandPalette.Instance;
};
